<script lang="js" setup>
import {defineProps} from "vue";

defineProps({
  href: {
    type: String,
    default: '#'
  },
  text: {
    type: String,
    required: true
  }
});
</script>

<template>
  <li>
    <a
      :href="href"
      class="relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full hover:opacity-100 focus:after:w-full focus:opacity-100 focus:outline-none opacity-50"
    >
      {{ text }}
    </a>
  </li>
</template>

<style scoped></style>
